const moment = require('moment');
export const serverDateFormat = (dateString: string) => {
  const date = moment(dateString);
  return date.format('DD.MM.YYYY HH:mm');
};
